import { LOGIN, LoginActionTypes, LoginState } from "../../../types/login/login"


const INITIAL_STATE: LoginState = {
    //loginToken: undefined,
}

export function LoginReducer(state = INITIAL_STATE, action: LoginActionTypes): LoginState {
    switch (action.type) {
        case LOGIN:
         //   return { ...state, loginToken: action.payload }
         return state
        default:
            return state
    }
}